<template>

    <section class="slider-wrap">

        <transition name="fade">
            <div class="loader" v-if="sliderLoading"></div>
        </transition>

        <div id="slider" class="slider" :class="{ 'is-loading': sliderLoading }">

            <template v-for="slide in slides">
                <div :class="['slider-cell', { 'is-video': slide.isVideo }]">
                    <iframe v-if="slide.isVideo" :data-src="slide.source" width="640" height="360" frameborder="0" title="After Effects Animation"></iframe>
                    <img v-else :data-src="slide.source" :alt="slide.alt">
                </div>
            </template>

        </div>

    </section>

</template>


<script>
import Flickity from 'flickity'
import imagesLoaded from 'imagesloaded'

import { Store, EventBus } from '@/main'

export default {

    data() {
        return {
            sliderLoading: false,
            slides: [
                { alt: 'Engross the Skies',    source: 'assets/img/graphics/artofmyself_engross-the-skies.jpg' },
                { alt: 'The Puppeteer',        source: 'assets/img/graphics/artofmyself_the-puppeteer.jpg' },
                { alt: 'Miles Away',           source: 'assets/img/graphics/artofmyself_miles-away.jpg' },
                { alt: 'Disintegration',       source: 'assets/img/graphics/artofmyself_disintegration.jpg' },
                // { alt: 'Ring',                 source: 'assets/img/graphics/artofmyself_ring.jpg' },
                { isVideo: true,               source: 'https://player.vimeo.com/video/123483515?loop=1&title=0&byline=0&portrait=0' },
                { alt: 'Elements',             source: 'assets/img/graphics/artofmyself_elements.jpg' },
                { alt: 'Magic Ball',           source: 'assets/img/graphics/artofmyself_magic-ball.jpg' },
                { alt: 'Flash',                source: 'assets/img/graphics/artofmyself_flash.jpg' },
                { alt: 'Tribute for Dark Art', source: 'assets/img/graphics/artofmyself_darkart-tribute.jpg '},
            ]
        }
    },

    created() {

        EventBus.$once('loadGraphics', () => this.loadImages())

    },


    methods: {

        loadImages() {

            if( !document.querySelector('.slider-cell img').hasAttribute('data-src') )
                return

            this.sliderLoading = true

            Store.sliderLoadedOnce = true

            let sliderContainer = document.querySelector('#slider')
            let sliderCells = document.querySelectorAll('.slider-cell')

            for( let i = 0; i < sliderCells.length; i++ ) {
                let image  = sliderCells[i].childNodes[0],
                    source = image.getAttribute('data-src')

                image.removeAttribute('data-src')
                image.setAttribute('src', source)
            }

            imagesLoaded( sliderContainer, () => {
                slider('#slider')
                setTimeout(() => this.sliderLoading = false, 300)
            })
        }
    }

}


function slider(el) {

    let phone = (window.innerWidth < 768)

    let flkty = new Flickity(el, {
        cellAlign:  'center',
        cellSelector: '.slider-cell',
        contain: true,
        //groupCells: '90%',
        pageDots: false,
        dragThreshold: 1,
        lazyLoad: true,
        freeScroll: phone
    })

    if( !phone ) {

        let slider   = document.querySelector(el),
            images   = slider.querySelectorAll(el + ' img, ' + el + ' iframe'),
            docStyle = document.documentElement.style,
            transformProp = typeof docStyle.transform == 'string' ? 'transform' : 'WebkitTransform'

        flkty.on('scroll', () => {

            flkty.slides.forEach((slide, i) => {
                let img = images[i],
                    x   = ( slide.target + flkty.x ) * -1/4

                img.style[ transformProp ] = 'translateX(' + x  + 'px)'
            })

        })

    }

}



</script>



// WEBPACK FOOTER //
// PortfolioGraphics.vue?6a7bef7a